import { useEffect, useState } from "react";
import { apiFetch } from "./api";

export type IncidentType =
  | "ACCIDENT" | "ROADWORK" | "CLOSED" | "WARNING"
  | "WEATHER" | "OTHER" | string;

export type TrafficItem = {
  id: string;
  lat: number;
  lon: number;
  incidentType: IncidentType;
  region: string | null;
  text: string;
  latestUpdate: string | null;
  concluded: boolean;
  createdTime: string | null;
  updatedTime: string | null;
  link: string | null;
  highlight: boolean;
};

const POLL_MS = 60_000;

/**
 * useTraffic — polls /api/traffic every minute and returns the current
 * list of incidents. Backend caches 60s on disk so the upstream DR feed
 * is hit at most once per minute regardless of how many tabs are open.
 */
export function useTraffic(active = true): TrafficItem[] {
  const [items, setItems] = useState<TrafficItem[]>([]);
  useEffect(() => {
    if (!active) return;
    let stopped = false;
    const tick = async () => {
      try {
        const r = await apiFetch("/api/traffic");
        if (!r.ok) return;
        const data = await r.json();
        if (!stopped && Array.isArray(data.items)) setItems(data.items);
      } catch {}
    };
    tick();
    const id = window.setInterval(tick, POLL_MS);
    return () => { stopped = true; clearInterval(id); };
  }, [active]);
  return items;
}
